export const PROFIT_SHARE_LABELS = [
  { id: 'other', color: '#00c5dc', label: 'Other' },
  { id: 'onlineCourses', color: '#ffb822', label: 'Online Courses' },
  { id: 'customDevelopment', color: '#716aca', label: 'Custom Development' },
];
